import React, { useState } from "react";
import { Button, Space } from "antd";
import { BrowserView, MobileView } from "react-device-detect";

import * as String from "../../commons/string";
import * as TypeDTO from "../../commons/typeDTO";

import KakaoMap from "../KakaoMap";
import CustomSheet from "../CustomSheet";
import IconNaver from "../../assets/images/home/rent/icon_navi_naver.png";
import IconKakao from "../../assets/images/home/rent/icon_navi_kakao.png";
import IconTmap from "../../assets/images/home/rent/icon_tmap.png";

const RentPlaceMap = ({ place, isGuide }: { place: TypeDTO.RentPlaceDto; isGuide?: boolean }) => {
    const [isOpenMap, setIsOpenMap] = useState<boolean>(false);

    const sendMapUrl = (type: "naver" | "tmap" | "kakao") => {
        let uri = "";

        if (type === "naver") {
            uri = `nmap://route/car?dlat=${place?.latitude}&dlng=${place?.longitude}&dname=${place?.address}`;
        } else if (type === "tmap") {
            uri = `tmap://route?goalname=${place?.address}&goalx=${place?.longitude}&goaly=${place?.latitude}`;
        } else if (type === "kakao") {
            uri = `kakaomap://route?ep=${place?.latitude},${place?.longitude}&by=CAR`;
        }

        window.location.href = uri;
    };

    return (
        <>
            <MobileView className="mobile">
                <div style={{ border: "1px solid #1C375A29", borderRadius: "4px" }}>
                    <KakaoMap
                        mapCenter={{
                            lat: Number(place?.latitude ?? 0),
                            lng: Number(place?.longitude ?? 0),
                        }}
                        mapStyle={{ aspectRatio: "5/3" }}
                        rentalLocation={{ list: place }}
                        guideRegion={place.region ? place.region : undefined}
                        guideMarker={place.marker ? place.marker : undefined}
                    />
                    <Space className="p-1" style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <p style={{ fontSize: 13 }}>{place?.address}</p>
                        <Button
                            type="text"
                            className="h-100 p-0"
                            style={{ fontWeight: "bold", color: "#005FDB", float: "right" }}
                            onClick={() => setIsOpenMap(true)}
                        >
                            {String.navigation}
                        </Button>
                    </Space>
                </div>
                <CustomSheet
                    isOpen={isOpenMap}
                    content={
                        <div style={{ padding: "0 1.5rem 1.5rem 1.5rem", overflowX: "hidden" }}>
                            <h5 className="mb-3">{String.linkProgram}</h5>
                            <div className="px-1 text-center" style={{ display: "flex", justifyContent: "space-around" }}>
                                <a className="h-100" onClick={() => sendMapUrl("naver")} target="_self" rel="noreferrer">
                                    <img src={IconNaver} width={60} />
                                    <p className="text-black">{String.naverMap}</p>
                                </a>
                                <a className="h-100" onClick={() => sendMapUrl("tmap")} target="_self" rel="noreferrer">
                                    <img src={IconTmap} width={60} style={{ marginBottom: "6px" }} />
                                    <p className="text-black">{String.tMap}</p>
                                </a>
                                <a className="h-100" onClick={() => sendMapUrl("kakao")} target="_self" rel="noreferrer">
                                    <img src={IconKakao} width={60} />
                                    <p className="text-black">{String.kakaoMap}</p>
                                </a>
                            </div>
                        </div>
                    }
                    snapHeight={200}
                    onClose={() => setIsOpenMap(false)}
                />
            </MobileView>
            <BrowserView className="browser">
                <KakaoMap
                    mapCenter={{
                        lat: Number(place.latitude ?? 0),
                        lng: Number(place.longitude ?? 0),
                    }}
                    mapStyle={{ aspectRatio: "5/3", marginTop: isGuide ? 0 : 10 }}
                    rentalLocation={{ list: place }}
                    guideRegion={place.region ? place.region : undefined}
                    guideMarker={place.marker ? place.marker : undefined}
                />
                {isGuide && (
                    <Space className="p-1" style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <p style={{ fontSize: 13 }}>{place?.address}</p>
                        <Button
                            type="text"
                            className="h-100 p-0"
                            style={{ fontSize: 13, lineHeight: "18px", fontWeight: "bold", color: "#005FDB", float: "right" }}
                            onClick={() =>
                                window.open(
                                    `https://map.kakao.com/link/to/${place?.rentRegionDescription},${place?.latitude},${place?.longitude}`
                                )
                            }
                        >
                            {String.navigation}
                        </Button>
                    </Space>
                )}
            </BrowserView>
        </>
    );
};

export default RentPlaceMap;
